export default "__VITE_ASSET__BBIIl0rn__ 584w";